// Drop-in replacements for the `aws-amplify/auth` functions the app used to read
// the session. Backed by the REST-issued JWT in localStorage, so call sites keep
// the same shapes (session.tokens.idToken.toString() / .payload, etc.) and only
// their import path changes from "aws-amplify/auth" to this module.

import {
  getStoredToken,
  getStoredAccessToken,
  decodeJwt,
  getTokenClaims,
} from "./token";

const wrap = (raw: string | null) =>
  raw ? { toString: () => raw, payload: decodeJwt(raw) || {} } : undefined;

export async function fetchAuthSession() {
  return {
    tokens: {
      idToken: wrap(getStoredToken()),
      accessToken: wrap(getStoredAccessToken()),
    },
  };
}

export async function getCurrentUser() {
  const claims = getTokenClaims();
  if (!claims?.sub) throw new Error("No authenticated user");
  return {
    username: claims["cognito:username"] || claims.email || claims.sub,
    userId: claims.sub,
  };
}

export async function fetchUserAttributes() {
  const claims = getTokenClaims() || {};
  // JWT claims already use Cognito attribute names (email, phone_number, custom:*).
  return { ...claims };
}

export async function signOut() {
  const { logout } = await import("../services/authService");
  await logout().catch(() => {});
}
